module.exports = __webpack_public_path__ + "static/img/venue.de5ec740.jpg";